import { memo, useEffect, useState } from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';

import { FilterMatchMode } from 'primereact/api';

const filters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    descricao: { value: null, matchMode: FilterMatchMode.CONTAINS }
};

export const TabelaArtigoDefeito = memo(function ({ data, dataProd, month, setor, type = 'mensal', defeitosengomagem3e4 = []}) {
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState('');
    const [showEngomagem3e4, setShowEngomagem3e4] = useState(false);
    
    const formatField = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(rowData[props.field]);
    }

    useEffect(() => {
        
        const allData = showEngomagem3e4 ? [...data, ...defeitosengomagem3e4] : [...data];
        console.log('ENGOMAGEM:', defeitosengomagem3e4);
        let arrayArtigos = [];
        let total = dataProd.reduce((sum, obj) => {
            return sum + parseFloat(obj.class1) + parseFloat(obj.class2) + parseFloat(obj.class3) + parseFloat(obj.class4);
        }, 0);

        dataProd.forEach((item) => {
            if(arrayArtigos.indexOf(parseInt(item.cod_artigo)) === -1){
                arrayArtigos.push(parseInt(item.cod_artigo));
            }
        });

        let artigoTotal = {}

        arrayArtigos.forEach((artigo) => {
            let filtroArtigo = dataProd.filter((element) => {
                return parseInt(element.cod_artigo) === artigo && parseInt(element.mes) === month;
            });
            artigoTotal[artigo] = filtroArtigo.reduce((sum, obj) => {
                return sum + parseFloat(obj.class1) + parseFloat(obj.class2) + parseFloat(obj.class3) + parseFloat(obj.class4);
            }, 0);
        });

        if(type === 'mensal') {
            let _data = allData.filter((element) => {
                return parseInt(element.mes) === month && element.cod_defeitotipo === setor && parseFloat(element.soma) > 0;
            });

            let _dataProd = dataProd.filter((element) => { return parseInt(element.mes) === month; });

            _dataProd.forEach((item) => {
                total += parseFloat(item.class1) + parseFloat(item.class2) + parseFloat(item.class3) + parseFloat(item.class4);
            });

            _data.forEach((element) => {
                element.porcentagem = (parseFloat(element.soma) / total * 100).toFixed(2);
                element.porcentagem_artigo = (parseFloat(element.soma) / artigoTotal[parseInt(element.cod_artigo)] * 100).toFixed(2);
            });

            setFilteredData(_data);
        } else if(type === 'media') {
            let _data = allData.filter((element) => {
                return element.cod_defeitotipo === setor && parseFloat(element.soma) > 0;
            });

            let defeitos = [];

            _data.forEach((item) => {
                if(defeitos.findIndex((element) => { return element === item.descricao }) === -1) {
                    defeitos.push(item.descricao);
                }
            });

            let newData = []

            defeitos.forEach((item) => {
                let filtro = _data.filter((element) => {
                    return element.descricao === item;
                });

                let artigos = [];

                filtro.forEach((item) => {
                    if(artigos.findIndex((element) => { return element === item.cod_artigo }) === -1) {
                        artigos.push(item.cod_artigo);
                    }
                });

                artigos.forEach((artigo) => {
                    let newItem = {};

                    let filtroArtigo = filtro.filter((element) => {
                        return element.cod_artigo === artigo;
                    });

                    let totalArtigo = dataProd.filter((element) => { return parseInt(element.cod_artigo) === parseInt(artigo) });
                    totalArtigo = totalArtigo.reduce((sum, obj) => {
                        return sum + parseFloat(obj.class1) + parseFloat(obj.class2) + parseFloat(obj.class3) + parseFloat(obj.class4);
                    }, 0);

                    let soma = filtroArtigo.reduce((sum, obj) => sum + parseFloat(obj['soma']), 0);

                    newItem.cod_artigo = artigo;
                    newItem.descricao = item;
                    newItem.soma = soma.toFixed(2);
                    newItem.porcentagem = (parseFloat(newItem.soma) / total * 100).toFixed(2);
                    newItem.porcentagem_artigo = (soma / totalArtigo * 100).toFixed(2);
    
                    newData.push(newItem);
                });
            });

            setFilteredData(newData);
        }
    }, [data, dataProd, setor, month, type, defeitosengomagem3e4, showEngomagem3e4]);

    let finalData = [...filteredData];

    const filteredByArt = search.length > 0 
        ? finalData.filter((element) => element.cod_artigo === parseInt(search)) 
        : finalData;

    return (
        <div className="p-col-6">
            <div className="p-d-flex p-flex-row p-jc-around">
                <span style={{ fontSize: 22 }}>{type === 'mensal' ? 'Mensal' : 'Anual' }</span>
                <InputText 
                    className="p-mb-2"
                    onChange={e => setSearch(e.target.value)}
                    value={search}
                />
            </div>
            {setor === 3 && (
                <div className="p-d-flex p-ai-center p-mb-2">
                    <Checkbox 
                        inputId="engomagem"
                        checked={showEngomagem3e4}
                        onChange={(e) => setShowEngomagem3e4(e.checked)}
                    />
                    <label htmlFor="engomagem" className="p-ml-2">
                        Exibir defeitos Engomagem 3 e 4
                    </label>
                </div>
            )}
            <DataTable
                filterDisplay="row"
                filters={filters}
                responsiveLayout="scroll"
                size="small"
                sortMode="multiple"
                value={filteredByArt}
            >
                <Column header="Art" field="cod_artigo" sortable />
                <Column header="Defeito" field="descricao" filter filterField="descricao" showFilterMenuOptions={false} sortable />
                <Column header="Metros" field="soma" body={formatField} sortable />
                <Column header="%" field="porcentagem" body={formatField} sortable />
                <Column header="% ART" field="porcentagem_artigo" body={formatField} sortable />
            </DataTable>
        </div>
    )
});